module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex mh4 mv4"
  }, [(Boolean(_vm.school.district_id)) ? _c('div', {
    staticClass: "pl-title"
  }, [_vm._v("\n    NOTE: You cannot edit this school's membership because it is part of a\n    district. To make teachers from this school paid users, you will need to\n    create a membership at the district level\n    "), _c('br'), _vm._v(" "), _c('pl-button', {
    staticClass: "pl-primary",
    nativeOn: {
      "click": function($event) {
        return _vm.goToDistrict.apply(null, arguments)
      }
    }
  }, [_vm._v("\n      Go to District")])], 1) : _c('div', [_c('div', {
    staticClass: "msm-title mb4 pt3"
  }, [_vm._v("Manage school Memberships")]), _vm._v(" "), _c('div', {
    staticClass: "mb4"
  }, [_c('h2', [_vm._v("Active Memberships")]), _vm._v(" "), _c('ul', _vm._l((_vm.active_memberships), function(membership) {
    return _c('li', {
      staticClass: "pl-subheading"
    }, [_c('div', {
      staticClass: "row col-xs between-xs ma0"
    }, [_c('span', [_c('strong', [_vm._v("Expiry Date")]), _vm._v(":\n              " + _vm._s(membership.end_date_readable))]), _vm._v(" "), _c('pl-menu', {
      attrs: {
        "menuSize": 5,
        "direction": "right"
      }
    }, [_c('pl-button', {
      staticClass: "pl-icon",
      staticStyle: {
        "margin": "0px",
        "min-height": "22px",
        "font-size": "12px"
      },
      attrs: {
        "slot": "menu_trigger"
      },
      slot: "menu_trigger"
    }, [_c('i', {
      staticClass: "fa fa-ellipsis-v",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v(" "), _c('ul', {
      attrs: {
        "menu-content": ""
      }
    }, [_c('li', {
      staticStyle: {
        "color": "#e53935"
      },
      on: {
        "click": function($event) {
          return _vm.openDeleteMembershipDialog(membership.id)
        }
      }
    }, [_vm._v("\n                  Delete Membership\n                  "), _c('i', {
      staticClass: "fas fa-trash-alt",
      staticStyle: {
        "color": "#e53935"
      }
    })])])], 1)], 1), _vm._v(" "), _c('strong', [_vm._v("Date Started")]), _vm._v(": " + _vm._s(membership.start_date_readable) + "\n          "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Membership Type")]), _vm._v(": " + _vm._s(membership.membership_type) + "\n          "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Number of Licenses")]), _vm._v(":\n          " + _vm._s(membership.number_of_licenses) + "\n        ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "mb4"
  }, [_c('h2', [_vm._v("Previous (Expired) Memberships")]), _vm._v(" "), _c('ul', _vm._l((_vm.expired_memberships), function(membership) {
    return _c('li', {
      staticClass: "pl-subheading"
    }, [_c('div', {
      staticClass: "row col-xs between-xs ma0"
    }, [_c('span', [_c('strong', [_vm._v("Expiry Date")]), _vm._v(":\n              " + _vm._s(membership.end_date_readable))]), _vm._v(" "), _c('pl-menu', {
      attrs: {
        "menuSize": 5,
        "direction": "right"
      }
    }, [_c('pl-button', {
      staticClass: "pl-icon",
      staticStyle: {
        "margin": "0px",
        "min-height": "22px",
        "font-size": "12px"
      },
      attrs: {
        "slot": "menu_trigger"
      },
      slot: "menu_trigger"
    }, [_c('i', {
      staticClass: "fa fa-ellipsis-v",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v(" "), _c('ul', {
      attrs: {
        "menu-content": ""
      }
    }, [_c('li', {
      staticStyle: {
        "color": "#e53935"
      },
      on: {
        "click": function($event) {
          return _vm.openDeleteMembershipDialog(membership.id)
        }
      }
    }, [_vm._v("\n                  Delete Membership\n                  "), _c('i', {
      staticClass: "fas fa-trash-alt",
      staticStyle: {
        "color": "#e53935"
      }
    })])])], 1)], 1), _vm._v(" "), _c('strong', [_vm._v("Date Started")]), _vm._v(": " + _vm._s(membership.start_date_readable) + "\n          "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Membership Type")]), _vm._v(": " + _vm._s(membership.membership_type) + "\n          "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Number of Licenses")]), _vm._v(":\n          " + _vm._s(membership.number_of_licenses) + "\n        ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "mb4"
  }, [_c('h2', [_vm._v("Create New Membership")]), _vm._v(" "), _c('div', {
    staticClass: "flex justify-start items-center ml1 mb2"
  }, [_vm._m(0), _vm._v(" "), _c('pl-input', {
    attrs: {
      "type": "date",
      "id": "start",
      "name": "membership-selection",
      "customStyle": "small-input",
      "required": ""
    },
    model: {
      value: (_vm.start_date),
      callback: function($$v) {
        _vm.start_date = $$v
      },
      expression: "start_date"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "flex justify-start items-center ml1 mb2"
  }, [_vm._m(1), _vm._v(" "), _c('pl-input', {
    attrs: {
      "type": "date",
      "id": "end",
      "name": "membership-selection",
      "customStyle": "small-input",
      "required": ""
    },
    model: {
      value: (_vm.end_date),
      callback: function($$v) {
        _vm.end_date = $$v
      },
      expression: "end_date"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "flex justify-start items-center ml1 mb2"
  }, [_vm._m(2), _vm._v(" "), _c('pl-select', {
    staticClass: "membership-type-select no-padding",
    staticStyle: {
      "width": "170px"
    },
    attrs: {
      "options": _vm.membership_types,
      "selected": 'Per ' + _vm.membership_type_selected
    },
    on: {
      "change": function($event) {
        _vm.membership_type_selected = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "flex justify-start items-center ml1 mb2"
  }, [_vm._m(3), _vm._v(" "), _c('pl-input', {
    attrs: {
      "type": "number",
      "placeholder": "Enter Number",
      "customStyle": "small-input"
    },
    model: {
      value: (_vm.number_of_licenses),
      callback: function($$v) {
        _vm.number_of_licenses = $$v
      },
      expression: "number_of_licenses"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "mv2"
  }, [_c('pl-button', {
    staticClass: "pl-primary",
    nativeOn: {
      "click": function($event) {
        return _vm.createNewSchoolMembership.apply(null, arguments)
      }
    }
  }, [_vm._v("\n          Create New\n        ")])], 1)])]), _vm._v(" "), (_vm.show_remove_membership_confirmation) ? _c('dialog-delete-confirm', {
    attrs: {
      "header": "Are you sure you want to delete this membership"
    },
    on: {
      "close": function($event) {
        _vm.show_remove_membership_confirmation = false
      },
      "actionConfirmed": _vm.removeSchoolMembership
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title small"
  }, [_c('span', {
    staticClass: "b"
  }, [_vm._v(" Start date:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title small"
  }, [_c('span', {
    staticClass: "b"
  }, [_vm._v(" End date:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title large"
  }, [_c('span', {
    staticClass: "b"
  }, [_vm._v(" Membership Type:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title large"
  }, [_c('span', {
    staticClass: "b"
  }, [_vm._v("Number of licenses: ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-139ca4fa!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/admin/adminPortal/memberships/adminMemberships.vue
// module id = 2099
// module chunks = 61